module.exports = __webpack_public_path__ + "img/nav-2-1.2cd9786f.png";